import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestDetailsMainSectionModule = withAsync({
	loader: lazyForPaint(
		() =>
			import(
				/* webpackChunkName: "forge-request-details-main-section" */ './request-details-main-section'
			),
	),
	LoadingSkeleton: () => null,
});

export { Headline } from './request-details-main-section';
